import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ExceptionItem, ExceptionItemState } from "./type";

const INITIAL_STATE: ExceptionItemState = {
  items: [],
};

const exceptionItemSlice = createSlice({
  name: "exceptionItem",
  initialState: INITIAL_STATE,
  reducers: {
    addItem(state, action: PayloadAction<ExceptionItem>) {
      state.items.push(action.payload);
    },
    removeItem(state, action: PayloadAction<number>) {
      state.items.splice(action.payload, 1);
    },
    resetItems() {
      return INITIAL_STATE;
    },
  },
});

export const { addItem, removeItem, resetItems } = exceptionItemSlice.actions;
export default exceptionItemSlice.reducer;
